export const IssueStatuses = [
  'NEW',
  'IN_PROGRESS',
  'RESOLVED',
  'REJECTED',
] as const;

export type IssueStatus = (typeof IssueStatuses)[number];

export interface IssueStatusHistory {
  from: IssueStatus;
  to: IssueStatus;
  comment: string;
  changedAt: number;
  email: string;
}

export interface Attachment {
  link: string;
  name: string;
}

export interface Issue {
  token: string;
  tenantToken: string;
  description: string;
  reportedAt: number;
  areaFloor: string;
  areaToken: string;
  status: IssueStatus;
  spaceChangeRequested: boolean;
  spaceName: string;
  spaceToken: string;
  attachments: Attachment[];
  reporterEmail: string;
  reporterToken: string;
  history: IssueStatusHistory[];
}
